import { RouterManager } from '@aclass/admin/managers';
import { QuoteTemplateStory } from '@aclass/admin/storage/actions';
import { IAdminState, IQuoteTemplateModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class QuoteTemplateSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:quote-template-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IQuoteTemplateModuleState['searchPageInitialized']>(['quoteTemplateModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(QuoteTemplateSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(QuoteTemplateStory.dryRunSearchPage());
    }
}
